import $ from "jquery";
import "slick-carousel";

let mobileSlider: any = null;
let desktopSlider: any = null;

const initMobileSlider = () => {
    if (window.innerWidth <= 768) {
        if (!mobileSlider) {
            $(".product-media-slider").each(function () {
                mobileSlider = $(this)
                    .find(".product__media-list")
                    .slick({
                        dots: true,
                        arrows: false,
                        infinite: true,
                        autoplay: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                        adaptiveHeight: false,
                        mobileFirst: true,
                        cssEase: 'linear',
                        touchThreshold: 10,
                       // appendDots: $(this).find('.product__media-gallery')
                    });
            });
        }
    } else if (mobileSlider) {
        mobileSlider.slick('unslick');
        mobileSlider = null;
    }
}

const initDesktopSlider = () => {
    if (window.innerWidth > 768) {
        if (!desktopSlider) {
            $(".image-gallery").each(function () {
                desktopSlider = $(this)
                    .find(".image-gallery__slider")
                    .slick({
                        dots: false,
                        arrows: true,
                        infinite: true,
                        autoplay: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        variableWidth: true,
                        prevArrow: $(this).find(".image-gallery__slider__arrow-prev"),
                        nextArrow: $(this).find(".image-gallery__slider__arrow-next"),
                    });
            });
        }
    } else if (desktopSlider) {
        desktopSlider.slick('unslick');
        desktopSlider = null;
    }
}

export const initImageMobileGalleries = () => {
    initMobileSlider();
    window.addEventListener('resize', initMobileSlider);
}

export const initImageDesktopGalleries = () => {
    initDesktopSlider();
    window.addEventListener('resize', initDesktopSlider);
}
